import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class Manager_EN extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Fragment>
                <text
                    className={ classes.root }
                    transform="matrix(0.92, -0.4, 0.4, 0.92, 31.29, 12.95)"
                >
                        F
                </text>,
                < text className = { classes.root } transform = "translate(35.92 10.93) rotate(-17.94)" >
                        r
                </text>,
                <text className={ classes.root } transform="translate(39.51 9.72) rotate(-11.88)">
                        e
                </text>,
                < text className = { classes.root } transform = "translate(44.73 8.61) rotate(-4.89)" >
                        e
                </text>,
                <text className={ classes.root } transform="matrix(1, 0.04, -0.04, 1, 50.08, 8.12)">
                        d
                </text>,
                < text className = { classes.root } transform = "translate(55.96 8.35) rotate(10.17)" >
                        o
                </text>,
                <text className={ classes.root } transform="translate(61.9 9.27) rotate(19.98)">
                        m
                </text>,
                < text className = { classes.root } transform = "translate(92.72 38.98) rotate(77.63)" >
                        T
                </text>,
                <text className={ classes.root } transform="translate(93.86 44.08) rotate(84.04)">
                        a
                </text>,
                < text className = { classes.root } transform = "translate(94.4 49.24) rotate(90.46)" >
                        s
                </text>,
                <text className={ classes.root } transform="translate(94.41 53.57) rotate(96.48)">
                        k
                </text>,
                < text className = { classes.root } transform = "translate(93.79 58.89) rotate(102.86)" >
                        s
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(92.78 63.16) rotate(107.28)"
                />,
                < text className = { classes.root } transform = "translate(10.9 66.94) rotate(-106.83)" >
                        P
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(-0.16, -0.99, 0.99, -0.16, 9.19, 61.25)"
                >
                        e
                </text>,
                < text className = { classes.root } transform = "translate(8.28 55.96) rotate(-91.95)" >
                        o
                </text>,
                <text className={ classes.root } transform="translate(8.06 49.93) rotate(-84.25)">
                        p
                </text>,
                < text className = { classes.root } transform = "translate(8.73 44.01) rotate(-78.57)" >
                        l
                </text>,
                <text className={ classes.root } transform="translate(9.2 41.37) rotate(-73.26)">
                        e
                </text>,

                < text className = { classes.root } transform = "translate(28.55 94.49) rotate(24.85)" >
                        S
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.95, 0.32, -0.32, 0.95, 34, 96.94)"
                >
                        t
                </text>,

                < text
                    className = { classes.root }
                    transform = "matrix(0.97, 0.24, -0.24, 0.97, 37.91, 98.25)"
                >
                        r
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.99, 0.12, -0.12, 0.99, 42.17, 99.33)"
                >
                        u
                </text>,
                < text className = { classes.root } transform = "translate(48.77 100.11) rotate(-0.46)" >
                        c
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.99, -0.11, 0.11, 0.99, 54.63, 100.01)"
                >
                        t
                </text>,
                < text className = { classes.root } transform = "translate(58.83 99.59) rotate(-12.6)" >
                        u
                </text>,

                <text className={ classes.root } transform="translate(65.22 98.07) rotate(-19.18)">
                        r
                </text>,
                < text
                    className = { classes.root }
                    transform = "matrix(0.9, -0.43, 0.43, 0.9, 69.35, 96.66)"
                >
                        e
                </text>
            </Fragment>
        );
    }
}
export default Manager_EN;

Manager_EN.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

Manager_EN.defaultProps = {
    classes: {}
};
